import { useState } from 'react';
import { Dropdown } from '../Dropdown/Dropdown';
import {
  Arrow,
  PopperWrapper,
  TooltipButton,
  TooltipPopper,
} from './Tooltip.styles';
import { TooltipPropTypes } from './Tooltip.types';

export function Tooltip({
  placement,
  TooltipIcon,
  message,
  className,
  height,
  width,
}: TooltipPropTypes): JSX.Element {
  const [buttonRef, setButtonRef] = useState<HTMLButtonElement>(null);
  const [expanded, setExpanded] = useState(false);

  function toggleExpanded() {
    setExpanded(!expanded);
  }

  function doExpand() {
    setExpanded(true);
  }

  function doCollapse() {
    setExpanded(false);
  }
  return (
    <Dropdown
      matchButtonWidth={false}
      animation="fade"
      buttonElement={() => (
        <TooltipButton
          ref={setButtonRef}
          onClick={toggleExpanded}
          onMouseEnter={doExpand}
          onMouseLeave={doCollapse}
          className={className}
        >
          <TooltipIcon />
        </TooltipButton>
      )}
      onClose={doCollapse}
      buttonReference={buttonRef}
      expanded={expanded}
      placement={placement}
      popperElement={(state) => (
        <PopperWrapper
          $height={height}
          $width={width}
          placement={state?.placement}
        >
          <TooltipPopper
            $height={height}
            $width={width}
            placement={state?.placement}
          >
            {message}

            <Arrow placement={state?.placement} />
          </TooltipPopper>
        </PopperWrapper>
      )}
    />
  );
}

Tooltip.defaultProps = {
  placement: 'top-start',
};
